export enum ErrorMessages {
  GENERIC_ERROR = 'An unexpected error happened. Please try again later',
}
